import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Clock, Zap, Star, ShieldCheck, Sparkles, ArrowRight } from "lucide-react";

const BENEFITS = [
  { icon: Zap, text: "Sin banners publicitarios en toda la web" },
  { icon: Clock, text: "Ver anuncios nuevos con 24 h de antelación" },
  { icon: Star, text: "Insignia Premium visible en tu perfil" },
  { icon: ShieldCheck, text: "Un anuncio destacado gratis al mes" },
];

export default function PremiumPage() {
  const navigate = useNavigate();
  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 lg:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 bg-[#3B5FB8] text-[#F8FAFC] text-[10px] font-mono uppercase tracking-[0.18em]">
            <Sparkles className="w-3 h-3" /> Próximamente
          </span>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#1A1A1A] leading-tight">
            Premium está en camino.
          </h1>
          <p className="mt-4 text-lg text-[#475569] leading-relaxed">
            Estamos afinando la experiencia Premium. En breve podrás suscribirte para disfrutar
            de anticipación, silencio publicitario y ventajas exclusivas. Por ahora todos los
            anuncios están disponibles para todo el mundo, sin cuenta Premium.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => (
            <div key={i} className="bg-white border border-[#E2E8F0] p-6 flex items-start gap-3">
              <div className="w-10 h-10 flex-shrink-0 bg-[#EEF2F7] flex items-center justify-center">
                <b.icon className="w-5 h-5 text-[#3B5FB8]" />
              </div>
              <p className="text-sm text-[#1A1A1A] leading-relaxed pt-2">{b.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 border border-[#E2E8F0] bg-white p-10 lg:p-14 text-center">
          <p className="eyebrow">Mientras tanto</p>
          <h2 className="mt-2 font-serif text-3xl lg:text-4xl font-semibold text-[#1A1A1A]">
            Publica sin límite. Destaca cuando quieras.
          </h2>
          <p className="mt-3 text-[#475569] max-w-xl mx-auto">
            Publicar es totalmente gratis. Si quieres máxima visibilidad, prueba a destacar tu
            anuncio o contrata un banner desde ya.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Button
              onClick={() => navigate("/publicar")}
              data-testid="premium-cta-publish"
              className="h-12 px-6 rounded-none bg-[#1A1A1A] hover:bg-[#2A2A2A] text-[#F8FAFC] font-medium"
            >
              Publicar anuncio
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              onClick={() => navigate("/anunciantes")}
              data-testid="premium-cta-banner"
              variant="outline"
              className="h-12 px-6 rounded-none border-[#CBD5E1] hover:border-[#3B5FB8]"
            >
              Contratar banner
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
